import { ITeasersContext, IFilterValues } from './teasersContext';

export enum TeasersActionTypes {
	SET_TEASERS = 'SET_TEASERS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_CONTENT_TYPE = 'SET_ID_CONTENT_TYPE',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_TEASER_ID_FOR_DELETION = 'SET_TEASER_ID_FOR_DELETION',
	SET_TEASER_ID_FOR_FULL_INFO = 'SET_TEASER_ID_FOR_FULL_INFO',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetTeasers {
	type: TeasersActionTypes.SET_TEASERS;
	payload: {
		teasers: ITeasersContext['teasers'];
		typeOfModalWindow: ITeasersContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: TeasersActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: ITeasersContext['searchString'];
		currentPage: ITeasersContext['currentPage'];
	};
}

interface ISetIDCustomer {
	type: TeasersActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ITeasersContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: TeasersActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: ITeasersContext['IDSelectedRestaurant'];
	};
}

interface ISetIDContentType {
	type: TeasersActionTypes.SET_ID_CONTENT_TYPE;
	payload: {
		IDSelectedContentType: ITeasersContext['IDSelectedContentType'];
	};
}

interface IResetSelectedControls {
	type: TeasersActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: TeasersActionTypes.SET_SORT_BY;
	payload: {
		sortBy: ITeasersContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: TeasersActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: ITeasersContext['countOfItems'];
	};
}

interface ISetCurrentPage {
	type: TeasersActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: ITeasersContext['currentPage'];
	};
}

interface ISetTeaserIDForDeletion {
	type: TeasersActionTypes.SET_TEASER_ID_FOR_DELETION;
	payload: {
		teaserIDForDeletion: ITeasersContext['teaserIDForDeletion'];
		typeOfModalWindow: ITeasersContext['typeOfModalWindow'];
	};
}

interface ISetTeaserIDForFullInfo {
	type: TeasersActionTypes.SET_TEASER_ID_FOR_FULL_INFO;
	payload: {
		teaserIDForFullInfo: ITeasersContext['teaserIDForFullInfo'];
	};
}

interface IChangeTypeOfDeleteTeaserModalWindow {
	type: TeasersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ITeasersContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: TeasersActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TTeasersActions =
	| ISetTeasers
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDContentType
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| ISetCurrentPage
	| ISetTeaserIDForDeletion
	| ISetTeaserIDForFullInfo
	| IChangeTypeOfDeleteTeaserModalWindow
	| ISetFiltersFromQueryString;
